import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const api = axios.create({
  baseURL: BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('combustible_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('combustible_token');
      localStorage.removeItem('combustible_usuario');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
